import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { switch_view } from '../../scene';
import { must_view_down_negative_direction } from '../../utility';
import view_y_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/view_y.svg';
import { img } from '@phi/components';
import ViewYTooptip from './ViewYTooltip';

export const ViewYIcon = view_y_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        disabled() {
            return this.coming_soon;
        },

        coming_soon() {
            return !this.state.loaded || this.state.tut_stage < 1;
        },

        alt() {
            return 'Switch view down the Y axis';
        },

        selected() {
            return this.state.tut_stage === 1;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                switch_view('y', must_view_down_negative_direction('y'));
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.selected,
            active: false,
            id: 'view-y-button',
            tippy: 'top',
            onClick: this.onClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(view_y_svg, this.alt),
            tooltip: ViewYTooptip
        });
    }
});
